<script setup lang="ts">
defineProps<{
  isChecking?: boolean;
  isAvailable?: boolean | null;
  shippingType?: 'Ground' | 'Apex' | null;
  message?: string;
  pincode?: string;
}>();
</script>

<template>
  <div v-if="pincode && pincode.length === 6" class="transition-all duration-200">
    <!-- Checking State -->
    <div 
      v-if="isChecking" 
      class="flex items-center gap-2 text-xs text-gray-500 bg-gray-50 border border-gray-200 px-3 py-2 rounded-[6px]"
    >
      <Icon name="lucide:loader-2" class="w-3.5 h-3.5 animate-spin text-gray-500 shrink-0" />
      <span>Checking Blue Dart shipping availability for <strong>{{ pincode }}</strong>...</span>
    </div>

    <!-- Available State -->
    <div 
      v-else-if="isAvailable === true" 
      class="flex items-start gap-2.5 text-xs text-emerald-800 bg-emerald-50/80 border border-emerald-200/80 px-3 py-2.5 rounded-[6px]"
    >
      <Icon name="lucide:truck" class="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" />
      <div class="flex flex-col gap-0.5">
        <span class="font-medium text-emerald-900">
          <template v-if="shippingType === 'Ground'">
            Ground Delivery
          </template>
          <template v-else-if="shippingType === 'Apex'">
            Express Air Delivery
          </template>
          <template v-else>
            Shipping is available for your address
          </template>
        </span>
        <span class="text-[11px] text-emerald-700/90 leading-tight">
          Delivery to pincode {{ pincode }} via Blue Dart Express
        </span>
      </div>
    </div>

    <!-- Unavailable State -->
    <div 
      v-else-if="isAvailable === false" 
      class="flex items-start gap-2.5 text-xs text-amber-900 bg-amber-50/80 border border-amber-200 px-3 py-2.5 rounded-[6px]"
    >
      <Icon name="lucide:alert-circle" class="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
      <div class="flex flex-col gap-0.5">
        <span class="font-semibold text-amber-950">
          Shipping is currently unavailable for this pincode ({{ pincode }}).
        </span>
        <span class="text-[11px] text-amber-800 leading-tight">
          Please check the pincode or try another delivery address.
        </span>
      </div>
    </div>
  </div>
</template>
